import { getInitials } from '@withjoy/joykit';

type PersonLike = Readonly<{ firstName?: string | null; lastName?: string | null }>;

export const getPersonName = (person: PersonLike): string => [person.firstName, person.lastName].filter(Boolean).join(' ') || '—';

export const getAvatarInitials = (person: PersonLike): string => getInitials({ firstName: person.firstName ?? undefined, lastName: person.lastName ?? undefined });
